export default __webpack_public_path__ + "static/media/nevigate.642f054d.svg";